import { withStyles } from "@material-ui/core";
const styles = () => ({
  confirmDialogContent: {
    display: "flex",
    flexDirection: "column",
  },
});
const ConfirmationDialogContent = ({ classes }) => (
  <div className={classes.confirmDialogContent}>
    <span>Please unassign the pickup before voiding.</span>
  </div>
);

export default withStyles(styles)(ConfirmationDialogContent);
